import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import {PrintRosterComponent} from './print-roster.component';
import {ComplianceItemService} from '../services/compliance-item.service';
import { RequestItemService } from '../services/request-item.service';
import { UserRequestService } from '../services/user-request.service';
import { PrintItemComponent } from './reports/item/print-item.component';

export function resolveComplianceItem(complianceItemService: ComplianceItemService, transition: Transition) {
    const params = transition.params();
    const cplId: string = params.cplId;

    return complianceItemService
        .getComplianceItem(cplId, "")
        .toPromise();
}

export function resolveRequestItem(requestItemService: RequestItemService, transition: Transition) {
    const params = transition.params();
    const requestId: string = params.requestId;

    return requestItemService
        .getRequestItem(requestId, false)
        .toPromise();
}

export function resolveUsers(
    transition: Transition,
    userRequestService: UserRequestService
) {
    const params = transition.params();
    const requestId: string = params.requestId;

return userRequestService
    .getUsersWhoHaveSubmittedRequestItem(requestId)
    .toPromise();
}

export function resolveItemCycles(transition: Transition, complianceItemService: ComplianceItemService, complianceItem) {
    const params = transition.params();
    let itemCycleID = null;

    const searchBy: string = params.searchBy;
    const statusId: number = params.statusId;
    const a48statusId: number = params.act48Status;
    const itemCycleId: string = params.itemCycleID;
    const approverUserId: string = params.approverUserId;
    const groupIds: string[] = params.groupIds ?? [];
    const cplId = complianceItem.ItemID;
    
    if(! itemCycleId ){
        if (complianceItem.ItemCycles.length > 0) {
            itemCycleID = complianceItem.ItemCycles[0].CycleID;
        }
    } else {
        itemCycleID = itemCycleId;
    }

    const largeLimit = 2000000000;
    if (itemCycleID) {
        return complianceItemService
            .getItemUserAssignments({ cplId, cycleId: itemCycleID, offset: 0, limit: largeLimit, searchBy, statusId, a48statusId, approverUserId, groupIds })
            .toPromise();
    }
    else {
        return complianceItemService
            .getUserUserAssignments({ cplId, offset: 0, limit: largeLimit, searchBy, statusId , a48statusId, approverUserId, groupIds })
            .toPromise();
    }
}

export const PrintStates: Ng2StateDeclaration[] = [
{
    name: 'print.request',
    url: '/request',
    abstract: true
}, 
{
    name: 'print.roster',
    url: '/roster/:cplId',
    views: {
        'content@print': {
            component: PrintRosterComponent
        }
    },
    resolve: [{
        token: 'cplItem',
        deps: [ComplianceItemService, Transition],
        resolveFn: resolveComplianceItem
    }]
},
{
    name: 'print.item',
    url: '/item/:cplId/:itemCycleID?statusId&searchBy&act48Status&approverUserId&groupIds',
    views: {
        'content@print': {
            component: PrintItemComponent
        }
    },
    params: {
        searchBy: { 
            raw:true,
            value: '',
        },
        groupIds: {
            array: true
        }
    },
    resolve: [{
        token: 'cplItem',
        deps: [ComplianceItemService, Transition],
        resolveFn: resolveComplianceItem
    }, {
        token: 'itemCycles',
        deps: [Transition, ComplianceItemService, 'cplItem'],
        resolveFn: resolveItemCycles
    }]
},
{
    name:'print.request.roster',
    url:'/roster/:requestId',
    views: {
        'content@print': {
            component: PrintRosterComponent
        }
    },
    resolve: [{
        token: 'cplItem',
        deps: [RequestItemService, Transition],
        resolveFn: resolveRequestItem
    },
    {
        token: "users",
        deps: [Transition, UserRequestService],
        resolveFn: resolveUsers
      }]
}];